exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.studentTask_wrap{padding:16px 16px 16px 16px;width:calc(100% - 32px);height:calc(100% - 32px);background-color:#f4f4f4\n}\n", "", {"version":3,"sources":["/data/data/jenkins/workspace/edu-gxzx-web-pro-new-study/src/components/views/studyCenter/switch/workAttendance/index.vue"],"names":[],"mappings":";AAiCA,kBAGA,4BACA,wBACA,yBACA,wBAAwC;CAKvC","file":"index.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.studentTask_wrap{\n\n\npadding: 16px 16px 16px 16px;\nwidth: calc(100% - 32px);\nheight: calc(100% - 32px);\nbackground-color: rgba(244, 244, 244, 1);\n\n \n\n\n}\n\n\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-78c6b6c6","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/views/studyCenter/switch/workAttendance/index.vue
// module id = v8y8
// module chunks = 96